export default __webpack_public_path__ + "static/media/ionicons.bb0605cc.svg";